import React, { useState } from 'react';
import '../CSS/Cart.css';
import Checkout from './Checkout';

function Cart({ cart, onClose, onUpdateQuantity, onRemoveItem, onCheckout }) {
  const [showCheckout, setShowCheckout] = useState(false);

  const handleProceedToCheckout = () => {
    setShowCheckout(true);
  };

  const handleBackToCart = () => {
    setShowCheckout(false);
  };

  const handlePaymentSuccess = () => {
    onCheckout();
    onClose();
  };

  if (showCheckout) {
    return (
      <Checkout
        cart={cart}
        total={cart.reduce((total, item) => total + (item.totalPrice * item.quantity), 0)}
        onBack={handleBackToCart}
        onSuccess={handlePaymentSuccess}
      />
    );
  }

  return (
    <div className="cart-overlay">
      <div className="cart-content">
        <div className="cart-header">
          <h2>Your Cart</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="cart-items">
          {cart.length === 0 ? (
            <div className="empty-cart">Your cart is empty</div>
          ) : (
            cart.map((item, index) => (
              <div key={index} className="cart-item">
                <div className="item-details">
                  <h3>{item.item_name}</h3>
                  <p className="item-options">
                    {item.selectedSize && `${item.selectedSize.name} `}
                    {item.selectedAddOns?.map(addOn => addOn.name).join(', ')}
                  </p>
                  <p className="item-price">${item.totalPrice.toFixed(2)}</p>
                </div>
                <div className="item-actions">
                  <div className="quantity-controls">
                    <button onClick={() => onUpdateQuantity(index, item.quantity - 1)}>-</button>
                    <span>{item.quantity}</span>
                    <button onClick={() => onUpdateQuantity(index, item.quantity + 1)}>+</button>
                  </div>
                  <button className="remove-button" onClick={() => onRemoveItem(index)}>
                    Remove
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        {cart.length > 0 && (
          <div className="cart-footer">
            <div className="cart-total">
              <span>Total:</span>
              <span>${cart.reduce((total, item) => total + (item.totalPrice * item.quantity), 0).toFixed(2)}</span>
            </div>
            <button className="checkout-button" onClick={handleProceedToCheckout}>
              Proceed to Checkout
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Cart; 